import { buildSentryRequest, type CaptureContext } from '@pageboss/shared';

// Browser Sentry capture (pure event/envelope build in
// @pageboss/shared/observability). Disabled-safe: no VITE_SENTRY_DSN → no-op.
// `keepalive` lets the POST survive a navigation; errors are swallowed —
// telemetry must never cascade into the app.
function captureException(dsn: string, err: unknown, ctx: CaptureContext): void {
  const req = buildSentryRequest(dsn, err, ctx, crypto.randomUUID().replace(/-/g, ''), Date.now());
  if (!req) return;
  void fetch(req.url, {
    method: 'POST',
    headers: req.headers,
    body: req.body,
    keepalive: true,
  }).catch(() => {});
}

// Wire global uncaught-error + unhandled-rejection capture. Call once from the
// SPA entry. The DSN is baked at build via VITE_SENTRY_DSN.
export function initSentry(serverName: string): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  const ctx: CaptureContext = { environment: import.meta.env.MODE, serverName };
  window.addEventListener('error', (e) => captureException(dsn, e.error ?? e.message, ctx));
  window.addEventListener('unhandledrejection', (e) => captureException(dsn, e.reason, ctx));
}
